import * as React from "react";
import cs from "classnames";
import PropTypes from "prop-types";
import { Button } from "@lululemon/ecom-pattern-library-button";
import { LoadingIndicator } from "@lululemon/ecom-pattern-library-loading-indicator";

import styles from "../styles/add-to-bag-button.component.module.scss";

const AddToBagBtn = React.forwardRef(function AddToBagButton(
  {
    btnAction,
    btnText,
    className,
    disabled,
    isAddToCartProcessing,
    ...extraProps
  },
  ref
) {
  return (
    <Button
      ref={ref}
      variant="filledImpact"
      onClick={isAddToCartProcessing ? null : btnAction}
      disabled={disabled}
      block
      className={cs(
        styles.addToBagBtn,
        {
          [styles.addToCartProcessing]: isAddToCartProcessing
        },
        className
      )}
      {...extraProps}
    >
      {isAddToCartProcessing ? <LoadingIndicator color="white" /> : btnText}
    </Button>
  );
});

AddToBagBtn.defaultProps = {
  btnAction: undefined,
  btnText: undefined,
  className: undefined,
  disabled: false,
  isAddToCartProcessing: false
};

AddToBagBtn.propTypes = {
  btnAction: PropTypes.func,
  btnText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isAddToCartProcessing: PropTypes.bool
};

export default AddToBagBtn;
